import colors from "theme/colors";

const styles = {
  flatlistStyle: {
    marginHorizontal: "15px",
    overflowX: "scroll",
    marginTop: 28,
    borderBottomColor: colors.neutral.mist,
    borderBottomWidth: 1,
    borderColor: "black",
  },
  cellNo: { flexDirection: "row", width: "80px" },
  cellCommon: { flex: 1, display: "flex", flexDirection: "row" },
  headerNo: { flexDirection: "row", width: "80px" },
  headerCommon: { flex: 1, display: "flex", flexDirection: "row" },
  cell: { textAlign: "center", flex: 1, display: "flex" },
  headerCenter: { textAlign: "center", flex: 1, display: "flex" },
};

export default styles;
